export enum DisplayTypeEnum {
  WEB = 'WEB',
  IOS = 'IOS',
  ANDROID = 'ANDROID',
}
